import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex col-md-12 mb-3 p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isNoIlos)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          variant: "outlined",
          color: "warning",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("no_ilos")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectIlos, (ilos, headerId) => {
          return (_openBlock(), _createElementBlock("div", {
            key: headerId,
            class: "mx-2"
          }, [
            (ilos && ilos.length)
              ? (_openBlock(), _createBlock(_component_v_checkbox, {
                  key: 0,
                  class: "mt-0",
                  "hide-details": "auto",
                  "model-value": _ctx.headerIlosChecked(ilos),
                  "onUpdate:modelValue": ($event: any) => (_ctx.updateChecked(ilos, $event ?? false)),
                  disabled: _ctx.headerIlosUnRemoveable(ilos, String(headerId)),
                  label: _ctx.$utils.servertranslate(ilos[0].header)
                }, null, 8, ["model-value", "onUpdate:modelValue", "disabled", "label"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ilos, (ilo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mx-4"
              }, [
                _createVNode(_component_v_checkbox, {
                  class: "mt-0",
                  "hide-details": "auto",
                  "model-value": !!_ctx.selectedIlosIds[ilo.iloId.toString()],
                  "onUpdate:modelValue": ($event: any) => (_ctx.updateChecked(ilo, $event ?? false)),
                  disabled: _ctx.unRemovableIlosIds[ilo.iloId.toString()],
                  label: ilo.ilo
                }, null, 8, ["model-value", "onUpdate:modelValue", "disabled", "label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ilo.subIlos, (sub, subIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: subIndex,
                    class: "mx-6"
                  }, [
                    _createVNode(_component_v_checkbox, {
                      class: "mt-0",
                      "hide-details": "auto",
                      "model-value": !!_ctx.selectedIlosIds[sub.subIloId.toString()],
                      "onUpdate:modelValue": ($event: any) => (_ctx.updateChecked(sub, $event ?? false)),
                      disabled: _ctx.unRemovableSubIlosIds[sub.subIloId.toString()],
                      label: sub.subIlo
                    }, null, 8, ["model-value", "onUpdate:modelValue", "disabled", "label"])
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}